import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type TrashIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M2 4H3.33333H14',
    'M12.6668 4.00001V13.3333C12.6668 13.687 12.5264 14.0261 12.2763 14.2762C12.0263 14.5262 11.6871 14.6667 11.3335 14.6667H4.66683C4.31321 14.6667 3.97407 14.5262 3.72402 14.2762C3.47397 14.0261 3.3335 13.687 3.3335 13.3333V4.00001M5.3335 4.00001V2.66668C5.3335 2.31305 5.47397 1.97392 5.72402 1.72387C5.97407 1.47382 6.31321 1.33334 6.66683 1.33334H9.3335C9.68712 1.33334 10.0263 1.47382 10.2763 1.72387C10.5264 1.97392 10.6668 2.31305 10.6668 2.66668V4.00001',
  ],
  '24': [
    'M3 6H5H21',
    'M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6',
  ],
  '32': [
    'M4 8H6.66667H28',
    'M25.3332 8V26.6667C25.3332 27.3739 25.0522 28.0522 24.5521 28.5523C24.052 29.0524 23.3737 29.3333 22.6665 29.3333H9.33317C8.62593 29.3333 7.94765 29.0524 7.44755 28.5523C6.94746 28.0522 6.6665 27.3739 6.6665 26.6667V8M10.6665 8V5.33334C10.6665 4.62609 10.9475 3.94782 11.4476 3.44772C11.9476 2.94762 12.6259 2.66667 13.3332 2.66667H18.6665C19.3737 2.66667 20.052 2.94762 20.5521 3.44772C21.0522 3.94782 21.3332 4.62609 21.3332 5.33334V8',
  ],
};

const TrashIcon = (props: TrashIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default TrashIcon;
